module.exports = __webpack_public_path__ + "static/media/1-4.e73df88a.PNG";